import { devtools } from "zustand/middleware";
import createMembersStore from "./members";
import createPackagesStore from "./packages";
import createFormLayoutStore from "./formLayout";
import { create } from "zustand";
import createAppStore from "./app";
import createPurchasesStore from "./purchases";
import createGiveawaysStore from "./giveaways";
import createSuperAdminStore from "./superadmin/superadmin";
import createAuthStore from "./auth/auth";
import createAlertsStore from "./alerts";

const useGlobalStore = create(
  devtools(
    (set, get) => ({
      members: createMembersStore(set),
      packages: createPackagesStore(set),
      formLayout: createFormLayoutStore(set),
      purchases: createPurchasesStore(set),
      giveaways: createGiveawaysStore(set),
      app: createAppStore(set),
      alerts: createAlertsStore(set, get),
      superadmin: createSuperAdminStore(set, get),
      resetAllStores: () => {
        const { members, packages, formLayout } = get();
        members.reset();
        packages.reset();
        formLayout.reset();
        createAuthStore.getState().reset();
      },
    }),
    {
      name: "Zustand",
    }
  )
);

export default useGlobalStore;
export { createAuthStore };
